import ActionButton from '@/components/bundles/share/grid/ActionButton'
import Page from '../../../../share/content/Page'

export default {
  mixins: [Page],
  data() {
    return {
      headerTitle: { title: "Baza poszkodowanych", description: "Lista" },
      service: "",
      actionShowUrlName: "",
      gridName: "grid_person",
      mainMenuButtons: [],
      modalVisible: false
    };
  },
  computed: {
    gridDataSource() {
      const vm = this;
      return { service: vm.service, url: "/person" };
    },
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: (data, type, row) => {
            return ActionButton.renderActionButtons(data, type, row,  [ { id: 0, event: 'show', title: 'Szczegóły', icon: 'folder-open', acl: { service: this.service, action: 'get_person' } } ], this)
          }
        },
        { id: 1, data: "name", title: this.$t("modals.newUser.company") },
        { id: 2, data: "forename", title: this.$t("modals.newUser.name") },
        { id: 3, data: "surname", title: this.$t("modals.newUser.surname") },
        { id: 4, data: "pesel", title: this.$t("modals.newUser.pesel") },
        { id: 5, data: "nip", title: this.$t("modals.newUser.nip") },
        { id: 6, data: "city", title: this.$t("modals.newUser.city") },
        { id: 7, data: "phone", title: this.$t("modals.newUser.phone") },
        { id: 8, data: "email", title: this.$t("modals.newUser.email") }
      ];
    }
  },
  methods: {
    addPerson() {
      this.modalVisible = true;
    },
    actionShow(id) {
      const vm = this;
      this.$router.push({ name: vm.actionShowUrlName, params: { id } });
    }
  }
};
